import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const InfoIcon = (props: SvgProps) => (
  <Svg
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <Path
      stroke="#548FC8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.5 7.833a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 0 .5.5M8 5.667l-.5-.188M14 8.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
    />
  </Svg>
);
export default InfoIcon;
